import React, { Fragment } from 'react';
import T from 'prop-types';
import { isEmpty, values, max } from 'lodash-es';

import StarsBar from '../../../components/HorizontalBars/StarsBar';
import ProgressBar from '../../../components/HorizontalBars/ProgressBar';
import { numberToHuman } from '../utils';

const stars = [5, 4, 3, 2, 1];

const TotalRatings = ({
  store,
  country,
  ratings = {},
}) => {
  const ratingToPercentage = (rating) => {
    const maxRating = max(values(ratings.ratings_breakdown));
    return (rating * 100) / maxRating;
  };

  return (
    <div className="widget-container about-page-total-ratings">
      <div className="ratings-headings">
        <h2 className="widget-title">Total Ratings</h2>
        {!isEmpty(ratings.ratings_breakdown) && <h3 className="ratings-country">{country}</h3>}
      </div>

      {!isEmpty(ratings.ratings_breakdown) && (
        <Fragment>
          <div className="ratings-total">
            <div className="ratings-total-number">{numberToHuman(ratings.total_ratings)}</div>
            <div className="ratings-total-stars">
              <StarsBar
                value={ratings.avg_rating * 0.2}
                size="lg"
              />
            </div>
          </div>

          <div className="ratings-breakdown">
            {stars.map(star => (
              <div key={star} className="ratings-breakdown-item">
                <span className="ratings-breakdown-item-title">{star} star</span>
                <ProgressBar
                  percentage={ratingToPercentage(ratings.ratings_breakdown[star])}
                  className="ratings-breakdown-item-progress"
                  backgroundColor="#FFDC85"
                  barWidth="100%"
                  showBarOnly
                />
                <span className="ratings-breakdown-item-number">{numberToHuman(ratings.ratings_breakdown[star])}</span>
              </div>
            ))}
          </div>
        </Fragment>
      )}

      {isEmpty(ratings.ratings_breakdown) && (
        <p className="ratings-empty-text">{store === 'google_play' ? 'GP' : 'iOS'} ratings are temporarily unavailable</p>
      )}
    </div>
  );
};

TotalRatings.propTypes = {
  ratings: T.shape({
    avg_rating: T.number,
    ratings_breakdown: T.shape({
      1: T.number,
      2: T.number,
      3: T.number,
      4: T.number,
      5: T.number,
    }),
    total_ratings: T.number,
  }),
  country: T.string,
  store: T.string.isRequired,
};

export default TotalRatings;
